import { dateInTheFuture } from './date';

const MAX_LENGTH = 255;
const MIN_LENGTH = 7;
const COOKIE_NAME = 'newsletterSignup';
const FIXED_NEWSLETTER_WINDOW_CLASS_NAME = '.c-newsletter-fixed-form';
const HIDE_FIXED_FORM_CLASS_NAME = '.js-hide-newsletter-signup';
const FIXED_FORM_CLASS_NAME = '.c-newsletter-fixed-form';

// Copied from apsis. Only reworked to function as a js module.
const correctEmailaddress = SubscriberForm => {
  if (SubscriberForm.pf_Email.value.length > MAX_LENGTH) {
    alert('Ange högst 255 tecken i fältet för e-postadress.');
    SubscriberForm.pf_Email.focus();
    return false;
  }

  if (SubscriberForm.pf_Email.value == '') {
    alert('Ange adressen i fältet för e-postadress');
    SubscriberForm.pf_Email.focus();
    return false;
  }

  if (SubscriberForm.pf_Email.value.length < MIN_LENGTH) {
    alert('Ange minst 7 tecken i fältet för e-postadress.');
    SubscriberForm.pf_Email.focus();
    return false;
  }

  var pf_Email = SubscriberForm.pf_Email.value;
  var reg = /^([a-zA-Z0-9_\-\.\+]*)([a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/;
  if (reg.test(pf_Email) == false) {
    alert('E-postadressen är inte giltig. Vänligen försök igen.');
    SubscriberForm.pf_Email.focus();
    return false;
  }

  var counter = 0;
  for (let i = 1; i <= SubscriberForm.pf_CounterMailinglists.value; i++) {
    var checkBoxName = 'pf_MailinglistName' + i;
    if (
      document.getElementsByName(checkBoxName)[0].checked ||
      document.getElementsByName(checkBoxName)[0].type == 'hidden'
    )
      counter++;
  }

  if (counter == 0) {
    alert('En eller flera e-postlistor krävs för detta formulär.');
    return false;
  }

  return true;
};

const writeCookie = (cookieName, date) =>
  (document.cookie = `${cookieName}=true; path=/;expires=${date}`);

const formSubmitEventHandler = e => {
  const form = e.currentTarget;
  const isValid = correctEmailaddress(form);

  if (!isValid) {
    e.preventDefault();
    return;
  }

  writeCookie(COOKIE_NAME, dateInTheFuture());
};

const initForms = () => {
  const forms = document.querySelectorAll('[name=SubscriberForm]');
  if (forms.length) {
    forms.forEach(item => {
      item.addEventListener('submit', formSubmitEventHandler);
    });
  }
};

const setVisibilityForFixedNewsletterWindow = () => {
  if (document.cookie.indexOf(COOKIE_NAME) === -1) {
    const fixedWindow = document.querySelector(
      FIXED_NEWSLETTER_WINDOW_CLASS_NAME,
    );

    if (fixedWindow) {
      fixedWindow.classList.remove('d-none');
      fixedWindow.classList.add('d-lg-block');
    }
  }
};

const hideFixedFormButton = e => {
  const button = e.currentTarget;
  const fixedForm = button.closest(FIXED_FORM_CLASS_NAME);
  fixedForm.classList.remove('d-lg-block');
  writeCookie(COOKIE_NAME, dateInTheFuture());
};

const initFixedFormHideButton = () => {
  const button = document.querySelector(HIDE_FIXED_FORM_CLASS_NAME);
  if (button) {
    button.addEventListener('click', hideFixedFormButton);
  }
};

export function init() {
  if (document.querySelector('body[show-newsletter-modal]')) {
    initForms();
    setVisibilityForFixedNewsletterWindow();
    initFixedFormHideButton();
  }

  // hide banner at the top
}
